<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid p-0">

    <div class="row">
      <div class="select_container col-4 col-md-3">
        <select class="form-control pl-1" v-bind:id="'select_' +  getId()" v-on:change="onChange">
          <option value="my" style="">{{$store.translate('my_calender')}}</option>
          <option value="all" style="">{{$t('all_calender')}}</option>
        </select>
      </div>
      <div class="select_container col-4 col-md-3" v-if="isAll">
        <select class="form-control select-search pl-1" v-bind:id="'selectloc_' +  getId()" v-on:change="onChangeLoc">
          <option value="0" style="">{{ $store.translate('select_location')}}</option>
          <option v-for="option in items" v-bind:value="option.locationid">
            {{ option.locationname }}
          </option>
        </select>
      </div>
      <div class="select_container col-4 col-md-3" v-if="isAll">
        <select class="form-control select-search pl-1" v-bind:id="'select_assigned_shift_' +  getId()" v-on:change="onChangeShift">
          <option value="0" style="">{{ $store.translate('shifts') }}</option>
          <option v-for="shift in shifts" v-bind:value="shift.SiteShiftId">
            {{ shift.Name }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>

  var items = [];
  var isAll = false;
  export default {
    name: "mycalander-filter",
    props: {

    },
    data() {
      return {
        items,
        isAll: false,
        shifts: [],
      };
    },
    methods: {      
      onChange() {
        this.isAll = $("#select_" + this.getId()).val() === 'all';
        if (this.isAll) {
          this.load();
          this.loadShifts();
        }
        var obj = { type: $("#select_" + this.getId()).val(), locId: 0, shiftId: 0 };
        var data = JSON.stringify(obj);
        vm.$root.$emit('doMyCalanderFilter', data);
      },
      onChangeLoc() {
        var obj = { type: $("#select_" + this.getId()).val(), locId: $("#selectloc_" + this.getId()).val(), shiftId: $("#select_assigned_shift_" + this.getId()).val() };
        var data = JSON.stringify(obj);
        vm.$root.$emit('doMyCalanderFilter', data);
      },
      onChangeShift() {
        this.onChangeLoc();
      },
      getId() {
        return this._uid;
      },
      async loadShifts() {
        try {
          this.shifts = [];
          var url = '/api/Admin/v1/SiteShifts';
          this.$http.get(url).then(async response => {
            this.shifts = response.data;
            this.$forceUpdate();            
          });
        }
        catch (err) {
        }
      },
      async load() {
        try {
          this.items = [];
          this.$http.get('/api/Locations/v1?').then(async response => {
            this.items = response.data;
            //$('#' + 'selectloc_' + this.getId()).select2();
            this.$forceUpdate();
          }).then((async response => {
            
          }
          ));
        } catch (err) {
          alert('some error:' + err)
        }
      }
    },
    watch: {

    },
    mounted() {
      
    }
  };
</script>

<style scoped>
  .select_container {
    width: 100%;
  }
</style>




// WEBPACK FOOTER //
// src/components/filter/mycalander-filter.vue